import lodashGet    from 'lodash/get'
import {isVNode}    from "../../../tools/utils";

export default {
  name: "EdDescriptionsItem",
  props: {
    column: {},
    data: {},
    index: Number,
  },
  render(h) {
    let {prop, formatter} = this.column
    let value = lodashGet(this.data, prop) || ''
    if (formatter) {
      let VNode = formatter(this.data, this.column, value, this.index)
      return isVNode(this, VNode) ? VNode : h('span', VNode)
    }
    return h('span', value)
  }
}
